import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import GenderService from "../../src/Services/Gender.service";
import LookupGeneric from "./lookupGeneric";
const GenderLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<Gender[]>' is not assignable to type '(ids: string[]) => Promise<Gender[]>'.
        fetchItemsById: (ids) => {
            return GenderService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return GenderService.searchAll(search);
        },
        optionRenderer: function optionRenderer(gender) {
            return _jsx("span", { children: gender.name });
        },
    });
};
export default GenderLookup;
